
(function () {
  'use strict';

  if (window.__bn_heart_tint) return;
  window.__bn_heart_tint = true;

  var BTN_SEL = '.wishlist-btn';
  var VAR = '--wl-heart-tint';
  var LS_KEY = 'bn_heart_tint_v2';
  var SAMPLE_W = 64;
  var MAX_STORE = 600;

  var COLOUR_RE = /^(rgb\(\d{1,3},\d{1,3},\d{1,3}\)|#[0-9a-f]{6})$/i;

  var mem = Object.create(null);
  var memV = Object.create(null);
  var inflight = Object.create(null);
  var queue = [];
  var nowTimer = null;
  var canvas = null;
  var ctx = null;

  function loadStore() {
    try {
      try { window.sessionStorage.removeItem('bn_heart_tint_v1'); } catch (e0) {   }
      var raw = window.localStorage.getItem(LS_KEY);
      if (!raw) return;
      var obj = JSON.parse(raw);
      if (!obj || typeof obj !== 'object') return;
      for (var k in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, k) || typeof obj[k] !== 'string') continue;
        var bar = obj[k].indexOf('|');
        if (bar < 0) continue;
        var colour = obj[k].slice(bar + 1);
        if (!COLOUR_RE.test(colour)) continue;
        mem[k] = colour;
        memV[k] = obj[k].slice(0, bar);
      }
    } catch (e) {   }
  }

  var saveTimer = null;
  function saveStore() {
    if (saveTimer) return;
    saveTimer = window.setTimeout(function () {
      saveTimer = null;
      try {
        var keys = Object.keys(mem);
        if (keys.length > MAX_STORE) keys = keys.slice(keys.length - MAX_STORE);
        var out = {};
        for (var i = 0; i < keys.length; i++) out[keys[i]] = (memV[keys[i]] || '') + '|' + mem[keys[i]];
        window.localStorage.setItem(LS_KEY, JSON.stringify(out));
      } catch (e) {   }
    }, 400);
  }

  function versionOf(src) {
    if (!src) return '';
    var m = /[?&]v=(\d{1,20})(?:&|$)/.exec(String(src));
    return m ? m[1] : '';
  }

  function known(handle, v) {
    if (!mem[handle]) return null;
    var sv = memV[handle] || '';
    if (sv && v && sv !== v) return null;
    return mem[handle];
  }

  function toLinear(c) {
    c /= 255;
    return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  }
  function fromLinear(c) {
    var v = c <= 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 1 / 2.4) - 0.055;
    return v;
  }
  function rgbToOklab(r, g, b) {
    var lr = toLinear(r), lg = toLinear(g), lb = toLinear(b);
    var l = Math.cbrt(0.4122214708 * lr + 0.5363325363 * lg + 0.0514459929 * lb);
    var m = Math.cbrt(0.2119034982 * lr + 0.6806995451 * lg + 0.1073969566 * lb);
    var s = Math.cbrt(0.0883024619 * lr + 0.2817188376 * lg + 0.6299787005 * lb);
    return [
      0.2104542553 * l + 0.7936177850 * m - 0.0040720468 * s,
      1.9779984951 * l - 2.4285922050 * m + 0.4505937099 * s,
      0.0259040371 * l + 0.7827717662 * m - 0.8086757660 * s
    ];
  }
  function oklabToRgb(L, a, b) {
    var l_ = L + 0.3963377774 * a + 0.2158037573 * b;
    var m_ = L - 0.1055613458 * a - 0.0638541728 * b;
    var s_ = L - 0.0894841775 * a - 1.2914855480 * b;
    var l = l_ * l_ * l_, m = m_ * m_ * m_, s = s_ * s_ * s_;
    var lr = 4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s;
    var lg = -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s;
    var lb = -0.0041960863 * l - 0.7034186147 * m + 1.7076147010 * s;
    var eps = 0.0005;
    if (lr < -eps || lg < -eps || lb < -eps || lr > 1 + eps || lg > 1 + eps || lb > 1 + eps) return null;
    return [
      Math.max(0, Math.min(255, Math.round(fromLinear(Math.max(0, Math.min(1, lr))) * 255))),
      Math.max(0, Math.min(255, Math.round(fromLinear(Math.max(0, Math.min(1, lg))) * 255))),
      Math.max(0, Math.min(255, Math.round(fromLinear(Math.max(0, Math.min(1, lb))) * 255)))
    ];
  }
  function lchToCss(L, C, h) {
    for (var c = C; c >= 0; c -= 0.004) {
      var rgb = oklabToRgb(L, c * Math.cos(h), c * Math.sin(h));
      if (rgb) return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
    }
    var g = oklabToRgb(L, 0, 0) || [40, 40, 40];
    return 'rgb(' + g[0] + ',' + g[1] + ',' + g[2] + ')';
  }

  var L_MIN = 0.34, L_MAX = 0.52;
  var C_MIN = 0.085, C_MAX = 0.19;
  var C_GREY = 0.022;
  var NEUTRAL = 'rgb(38,38,40)';

  function decide(px, pct) {
    if (typeof pct !== 'number') pct = 0.75;
    var n = px.length / 4;
    if (!n) return { colour: NEUTRAL, chromatic: false };
    var Ls = [], Cs = [], pairs = [], sx = 0, sy = 0, wsum = 0, used = 0;
    for (var i = 0; i < px.length; i += 4) {
      if (px[i + 3] < 200) continue;
      var lab = rgbToOklab(px[i], px[i + 1], px[i + 2]);
      var C = Math.sqrt(lab[1] * lab[1] + lab[2] * lab[2]);
      var h = Math.atan2(lab[2], lab[1]);
      var w = Math.pow(C, 1.5);
      sx += Math.cos(h) * w; sy += Math.sin(h) * w; wsum += w;
      Ls.push(lab[0]); Cs.push(C); pairs.push([C, lab[0]]); used++;
    }
    if (!used) return { colour: NEUTRAL, chromatic: false };
    Ls.sort(function (a, b) { return a - b; });
    Cs.sort(function (a, b) { return a - b; });
    var C = Cs[Math.min(Cs.length - 1, Math.floor(Cs.length * pct))];
    if (C < C_GREY || wsum <= 0) return { colour: NEUTRAL, chromatic: false };
    var hue = Math.atan2(sy / wsum, sx / wsum);

    var lit = [];
    for (var k = 0; k < pairs.length; k++) if (pairs[k][0] >= C * 0.7) lit.push(pairs[k][1]);
    var L;
    if (lit.length >= 4) {
      lit.sort(function (a, b) { return a - b; });
      L = lit[Math.floor(lit.length * 0.5)];
    } else {
      L = Ls[Math.floor(Ls.length * 0.5)];
    }

    if (L > L_MAX) L = L_MAX;
    if (L < L_MIN) L = L_MIN;
    if (C < C_MIN) C = C_MIN;
    if (C > C_MAX) C = C_MAX;
    return { colour: lchToCss(L, C, hue), chromatic: true };
  }

  function regionFor(btn, img, iw, ih) {
    var b, r;
    try { b = btn.getBoundingClientRect(); r = img.getBoundingClientRect(); }
    catch (e) { return null; }
    if (!r.width || !r.height) return null;
    var u = (b.left + b.width / 2 - r.left) / r.width;
    var v = (b.top + b.height / 2 - r.top) / r.height;
    if (u < -0.2 || u > 1.2 || v < -0.2 || v > 1.2) { u = 0.5; v = 0.5; }
    u = Math.max(0, Math.min(1, u));
    v = Math.max(0, Math.min(1, v));
    var w = Math.max(6, Math.round(iw * 0.34));
    var h = Math.max(6, Math.round(ih * 0.34));
    var x = Math.round(u * iw - w / 2);
    var y = Math.round(v * ih - h / 2);
    return {
      x: Math.max(0, Math.min(iw - w, x)),
      y: Math.max(0, Math.min(ih - h, y)),
      w: w, h: h
    };
  }

  function thumbUrl(src) {
    if (!src) return null;
    try {
      var u = new URL(src, window.location.href);
      if (!/\/cdn\/shop\//.test(u.pathname)) return null;
      u.protocol = 'https:';
      u.searchParams.set('width', String(SAMPLE_W));
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.href;
    } catch (e) { return null; }
  }

  function cardImage(btn) {
    var scope = btn.closest('.card-gallery, product-card, .wishlist-card, .trending__card');
    if (!scope) return null;
    return scope.querySelector('img');
  }

  function sourceOf(btn) {
    var img = cardImage(btn);
    var url = thumbUrl(img && (img.currentSrc || img.src));
    if (!url) {
      img = null;
      url = thumbUrl(btn.dataset && btn.dataset.productImage);
    }
    return { img: img, url: url, v: versionOf(url) };
  }

  function resolve(btn, handle, done) {
    var src = sourceOf(btn);
    var img = src.img;
    var url = src.url;
    if (!url) { done(NEUTRAL, ''); return; }

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';
    probe.onload = function () {
      try {
        var iw = probe.naturalWidth, ih = probe.naturalHeight;
        if (!iw || !ih) { done(NEUTRAL, src.v); return; }
        if (!canvas) {
          canvas = document.createElement('canvas');
          ctx = canvas.getContext('2d', { willReadFrequently: true });
        }
        if (!ctx) { done(NEUTRAL, src.v); return; }
        canvas.width = iw; canvas.height = ih;
        ctx.clearRect(0, 0, iw, ih);
        ctx.drawImage(probe, 0, 0, iw, ih);
        var reg = (img && regionFor(btn, img, iw, ih)) || { x: 0, y: 0, w: iw, h: ih };
        var got = decide(ctx.getImageData(reg.x, reg.y, reg.w, reg.h).data);

        if (!got.chromatic) {
          var wholeData = (reg.w !== iw || reg.h !== ih)
            ? ctx.getImageData(0, 0, iw, ih).data
            : ctx.getImageData(reg.x, reg.y, reg.w, reg.h).data;
          var whole = decide(wholeData, 0.92);
          if (whole.chromatic) got = whole;
        }
        done(got.colour, src.v);
      } catch (e) {
        done(NEUTRAL, src.v);
      }
    };
    probe.onerror = function () { done(NEUTRAL, null); };
    probe.src = url;
  }

  function paint(btn, colour) {
    try { btn.style.setProperty(VAR, colour); btn._wlTintPainted = colour; } catch (e) {   }
  }

  function run(job) {
    var btn = job[0], handle = job[1];
    if (btn._wlTintHandle !== handle) return;
    var hit = known(handle, sourceOf(btn).v);
    if (hit) { paint(btn, hit); return; }
    if (inflight[handle]) { inflight[handle].push(btn); return; }
    inflight[handle] = [btn];
    resolve(btn, handle, function (colour, sv) {
      if (sv !== null) {
        mem[handle] = colour;
        memV[handle] = sv || '';
        saveStore();
      }
      var waiting = inflight[handle] || [];
      delete inflight[handle];
      for (var i = 0; i < waiting.length; i++) {
        if (waiting[i]._wlTintHandle === handle) paint(waiting[i], colour);
      }
    });
  }

  function drain() {
    nowTimer = null;
    while (queue.length) run(queue.shift());
  }

  function schedule() {
    if (queue.length && nowTimer === null) nowTimer = window.setTimeout(drain, 0);
  }

  function want(btn) {
    if (!btn || !btn.dataset) return;
    var handle = btn.dataset.productHandle;
    if (!handle) return;
    if (btn._wlTintHandle && btn._wlTintHandle !== handle) {
      btn._wlTintQueued = false;
      try {
        if (btn._wlTintPainted && btn.style.getPropertyValue(VAR).trim() === btn._wlTintPainted) btn.style.removeProperty(VAR);
      } catch (e) {   }
      btn._wlTintPainted = null;
    }
    var first = btn._wlTintHandle !== handle;
    btn._wlTintHandle = handle;
    var src = sourceOf(btn);
    if (first) {
      var pre = '';
      try { pre = (btn.style.getPropertyValue(VAR) || '').trim(); } catch (e0) { pre = ''; }
      if (pre && pre !== btn._wlTintPainted && COLOUR_RE.test(pre)) {
        if (mem[handle] !== pre || memV[handle] !== src.v) {
          mem[handle] = pre;
          memV[handle] = src.v;
          saveStore();
        }
        return;
      }
    }
    var hit = known(handle, src.v);
    if (hit) { paint(btn, hit); return; }
    if (btn._wlTintQueued) return;
    btn._wlTintQueued = true;
    queue.push([btn, handle]);
    schedule();
  }

  function sweep(root) {
    var list = (root || document).querySelectorAll(BTN_SEL + '.active');
    for (var i = 0; i < list.length; i++) want(list[i]);
  }

  function boot() {
    loadStore();
    sweep(document);

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.type === 'attributes') {
            var t = m.target;
            if (t.classList && t.classList.contains('active') && t.matches && t.matches(BTN_SEL)) want(t);
          } else if (m.addedNodes) {
            for (var j = 0; j < m.addedNodes.length; j++) {
              var node = m.addedNodes[j];
              if (node.nodeType !== 1) continue;
              if (node.matches && node.matches(BTN_SEL + '.active')) want(node);
              if (node.querySelectorAll) sweep(node);
            }
          }
        }
      }).observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());
